module.exports = __webpack_public_path__ + "static/media/TowerIconYellow.a4a0b9d0.svg";